/**
 * Newsfeed-Helfer: Konstanten und Formatierung.
 * Aus Newsfeed.jsx extrahiert, um die Hauptdatei kompakt zu halten.
 */
import {
  AlertTriangle, Monitor, Building2, Tag, Globe, Building, MapPin,
} from 'lucide-react';

export const CATEGORY_ICONS = {
  'alert-triangle': AlertTriangle,
  'monitor': Monitor,
  'building': Building2,
  'tag': Tag,
};

export const VISIBILITY_OPTIONS = [
  { value: 'all', label: 'Gesamte Gesellschaft', icon: Globe },
  { value: 'branch', label: 'Niederlassung(en)', icon: Building },
  { value: 'location', label: 'Standort(e)', icon: MapPin },
];

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Gerade eben';
  if (mins < 60) return `vor ${mins} Min.`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `vor ${hours} Std.`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `vor ${days} Tag(en)`;
  return new Date(dateStr).toLocaleDateString('de-DE');
}

export const isImageFile = (contentType) => contentType?.startsWith('image/');

export const getFileDownloadUrl = (fileId) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  return `${baseUrl}/api/news/files/${fileId}?token=${token}`;
};
